import React from 'react';

const AccountSuspended: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-amber-50">
      <div className="bg-white p-8 rounded shadow-md max-w-md w-full text-center border border-amber-200">
        <h1 className="text-2xl font-bold text-amber-700 mb-4">Account Suspended</h1>
        <p className="text-amber-800 mb-6">
          Your account is suspended. Email <a href="mailto:info@hivetivity.com" className="underline text-blue-600">info@hivetivity.com</a> if you need help.
        </p>
        <button
          className="bg-amber-600 text-white px-4 py-2 rounded hover:bg-amber-700 transition"
          onClick={() => window.location.href = 'mailto:info@hivetivity.com'}
        >
          Contact Support
        </button>
      </div>
    </div>
  );
};

export default AccountSuspended; 